import API from "../BaseURL";

const configJson = {
    headers: {
        "content-type": "application/json",
    },
};


export async function getAllSoilAnalysis() {
    const res = API.get(`/soil_analysis/`, configJson);
    return res;
}

export async function getSoilAnalysisInfo(soilAnalysis_id) {
   const res = API.get(`/soil_analysis/${soilAnalysis_id}`, configJson);

    return (await res).data;
}

export async function createSoilAnalysis(data) {
    const res = API.post(`/soil_analysis/`, data, configJson);
    return res;
}

export async function updateSoilAnalysis(soilAnalysis_id, data) {
    const res = API.put(`/soil_analysis/${soilAnalysis_id}/`, data, configJson);
    return res;
}


export async function deleteSoilAnalysis(soilAnalysis_id) {
    const res = API.delete(`/soil_analysis/${soilAnalysis_id}/`, configJson);
    return res;
}


export async function getSoilAnalysisByExploitation(exploitation_id) {
    const res = API.get(`/soil_analysis/exploitation/${exploitation_id}`, configJson);
    return res;
}


export async function getLastSoilAnalysis(exploitation_id) {
    const res = API.get(`/soil_analysis/last/exploitation/${exploitation_id}`, configJson);
    return res;
}
